module.exports = __webpack_public_path__ + "static/media/stedelijk.5b208ffb.jpg";